import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TrailerHero() {
  return <section id="refrigeratedtrailerhero" data-nav="light" className="relative w-full overflow-hidden bg-background py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8">
          {/* Left Column: Text & CTA */}
          <div className="flex flex-col items-start lg:col-span-6 xl:col-span-7">
            <h1 className="font-default text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              53-Foot Reefer Trailer Rentals
            </h1>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground sm:text-lg">Fridge Fleet offers 53-foot reefer trailer rentals for temporary refrigerated storage needs in Southern California and Southern Nevada.</p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/ContactRequestAQuotePage">
                  Request a Quote
                </Link>
              </Button>
            </div>
          </div>

          {/* Right Column: Image Block */}
          <div className="w-full lg:col-span-6 xl:col-span-5">
            <div className="aspect-[16/11] w-full overflow-hidden rounded-lg border border-border bg-muted shadow-md">
              <img src="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png" alt="Fridge Fleet 53-foot reefer trailer for temporary refrigerated storage" className="w-full h-full rounded-lg object-cover" style={{
              objectPosition: '30% 40%'
            }} />
            </div>
          </div>
        </div>
      </div>
    </section>;
}